var map = {
	"./auth0.svg": 5894,
	"./azure.svg": 690,
	"./cmake.svg": 1213,
	"./cpp.svg": 290,
	"./css.svg": 3588,
	"./dart.svg": 8069,
	"./django.svg": 2549,
	"./docker.svg": 2844,
	"./flask.svg": 5461,
	"./flutter.svg": 4331,
	"./gcp.svg": 4560,
	"./git.svg": 2929,
	"./github.svg": 8288,
	"./html.svg": 3466,
	"./huggingface.svg": 7172,
	"./java.svg": 6554,
	"./javascript.svg": 6146,
	"./kotlin.svg": 6744,
	"./kubernetes.svg": 1922,
	"./linkedin.svg": 7774,
	"./linux.svg": 1439,
	"./maven.svg": 8119,
	"./mysql.svg": 8262,
	"./nextjs.svg": 2845,
	"./nodejs.svg": 199,
	"./openshift.svg": 5930,
	"./postgresql.svg": 7196,
	"./python.svg": 4978,
	"./pytorch.svg": 3178,
	"./qt.svg": 6344,
	"./react.svg": 485,
	"./redis.svg": 5555,
	"./sklearn.svg": 6104,
	"./spring.svg": 5411,
	"./sqlite.svg": 7439,
	"./stripe.svg": 6107,
	"./supabase.svg": 8965,
	"./twitter.svg": 8901,
	"./typescript.svg": 9785,
	"./vercel.svg": 8914,
	"./vue.svg": 8698
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9284;